import { Observable } from "rxjs";
import { Parameter } from "../../../../../@core/interfaces/common/parameter";


export interface ItemScrapEntryParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}


export interface ItemScrapEntry {
    [x: string]: any;
    ItemId:string,
    qty:string,
    expiryDate:Date,
    batchNo:string,
    scrapReasonId:number,
    scrapDoneBy: any,
    scrapNotes:string,
    scrapDoneDate:Date,
    scrapApprovedBy: any,
    scrapApprovedDate: Date,
    scrapApprovedFlag:string,
    CreatedBy: any,
    CreatedDate:Date,
    CreatedIP: any,
    UpdatedDate: Date,
    UpdatedBy: any,
    UpdatedIP: any,   
    branchId: any,
    tenantId: any,
    Id: any
}

export interface ItemIntDep {
  name: string,
  code: string,
  location: string,
  createdBy: any,
  createdDate: Date,
  createdIP: any,
  updatedDate: Date,
  updatedBy: any,
  updatedIP: any,
  branchId: any,
  tenantId: any,
  id?: any
  type: string,
  hospname: string,
  hospaddress1: string,
  hospaddress2: string,
  hospcity: string,
  hosppincode: string,
  hosplandlineno: string,
  hospmobileno: string,
  hospaltcontactno: string,
  hospemail: string,
  hospcontactperson: string,
  hospcontactpersondesg: string
}

export interface ItemOpeningStockEntry {
  batchNumber: string;
  expiryDate: string;
  gstTotalPer: string;
  pricePerStrips: string;
  sellPriceStrip: string;
  mrpPerStrip: any;
  stockIn: string;
  unitCostPrice: string;
  unitSellPrice: string;
  unitMrpPrice: string;
  itemList: any;
}

export interface InventorycreditNotes{
    id?:any;
    supCreditNoteNo:string;
    supId:string;
    supNotes:string;
    itemCreditNoteReasonId:number;
    amount:any;
    supCreditnoteDate:Date;
    createdBy:number;
    createdDate:Date;
    updatedBy:any;
    updatedDate:Date;
    tenantId:any;
    branchId:any;
    [x: string]: any;

}

export interface InventoryDebitNotes{
    id?:any;
    debitNoteDate?:Date;
    debitNoteNo?:string;
    regId?:any;
    notes?:string;
    itemDebitNoteReasonId:number;
    amount?:any;
    createdBy?:any;
    createdDate?:Date;
    updatedBy?:any;
    updatedDate?:Date;
    tenantId?:any;
    branchId?:any;
}
export abstract class CommonInventoryData {
    abstract updateProductList(url: string, params: { prnId: number; }):Observable<any[]>;
    abstract updated(url: string, params: {languageVariableId: number; }):Observable<any[]>;
    abstract updatedtrans(url: string, params: {translationID: number; }):Observable<any[]>;
    abstract updateProduct(url: string, params: { prnId: number; }):Observable<any[]>;
    abstract list(url: string): Observable<any[]>;
    abstract listAssessmentCategoryMst(url: string, tenantId: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any>;
    abstract update(url: string, data: any): Observable<any>;
    abstract updateAssessmentCategoryMst(url: string, data: any, id: number, shouldReturn: boolean): Observable<any>;
    abstract createAssessmentCategoryMst(url: string, data: any, shouldReturn: boolean): Observable<any>;
    abstract searchList(url: string, data: any): Observable<any>;
    abstract getById(url: string): Observable<any>;
    abstract loadRiskAssesTransMst(url: string, det): Observable<any[]>;
    abstract searchwithParams(url: string, det, data): Observable<any[]>;

    //VOPD
    abstract vopdlist(url:string , options:any): Observable<any>;
    abstract vopdAppPut(url:string , options:any): Observable<any>;
    abstract vopd(url: string, options:any):Observable<any>;
    abstract vopdAppGet(url:string , options:any): Observable<any>;
    abstract vopdOrgGet(url:string , options:any): Observable<any>;
    abstract vopdSessionGet(url:string , options:any): Observable<any>;
    abstract vopdUpdate(url:string ,data:any): Observable<any>;

}